/**
 * Various common date formats used by momentjs.
 */

const TIME_SEP = ':';

// /////////////////////////////////////////////////
// begin basic units

const TZ = 'z';
const YEAR = 'YYYY';
const MONTH = 'MMM';
const DAY = 'D';
const HOUR24 = 'HH';
const HOUR12 = 'h';
const CHART_HOUR12 = '%l:%M %p';
const CHART_HOUR24 = '%H:%M';
const CHART_DAY = '%e %b';
const CHART_WEEK = '%e %b';
const AMPM = 'A';
const MINUTE = 'mm';
const SECOND = 'ss';

// //////////////////////////////////////////////////
// begin date formats

const DAY_OF_YEAR = `${DAY} ${MONTH}`; // 12 Feb
const DATE = `${DAY} ${MONTH} ${YEAR}`; // 12 Feb 2019
const DATE_FIELD = `MM/DD/yyyy`; // 02/12/2019

const TIME_MIN_24H = `${HOUR24}${TIME_SEP}${MINUTE}`; // 13:14
const TIME_MIN_24H_TZ = `${TIME_MIN_24H} ${TZ}`; // 13:14 MST
const TIME_SEC_24H = `${TIME_MIN_24H}${TIME_SEP}${SECOND}`; // 13:14:00
const TIME_SEC_24H_TZ = `${TIME_SEC_24H} ${TZ}`; // 13:14:00 MST
const TIME_MIN_12H = `${HOUR12}${TIME_SEP}${MINUTE} ${AMPM}`; // 1:14 PM
const TIME_MIN_12H_TZ = `${TIME_MIN_12H} ${TZ}`; // 1:14 PM MST
const TIME_SEC_12H = `${HOUR12}${TIME_SEP}${MINUTE}${TIME_SEP}${SECOND} ${AMPM}`; // 1:14:00 PM
const TIME_SEC_12H_TZ = `${TIME_SEC_12H} ${TZ}`; // 1:14:00 PM MST

const DATETIME_MIN_24H = `${DATE} ${TIME_MIN_24H}`; // 12 Feb 2019 13:14 MST
const DATETIME_SEC_24H = `${DATE} ${TIME_SEC_24H}`; // 12 Feb 2019 13:14:00 MST
const DATETIME_MIN_24H_TZ = `${DATETIME_MIN_24H} ${TZ}`; // 12 Feb 2019 13:14 MST
const DATETIME_SEC_24H_TZ = `${DATETIME_SEC_24H} ${TZ}`; // 12 Feb 2019 13:14:00 MST

const DATETIME_MIN_12H = `${DATE} ${TIME_MIN_12H}`; // 12 Feb 2019 1:14 PM
const DATETIME_SEC_12H = `${DATE} ${TIME_SEC_12H}`; // 12 Feb 2019 13:14:00 PM
const DATETIME_MIN_12H_TZ = `${DATETIME_MIN_12H} ${TZ}`; // 12 Feb 2019 1:14 PM MST
const DATETIME_SEC_12H_TZ = `${DATETIME_SEC_12H} ${TZ}`; // 12 Feb 2019 1:14:00 PM MST

// These two are just like DATETIME_MIN_12H, but omitting year:
const DOYTIME_MIN_12H = `${DAY_OF_YEAR} ${TIME_MIN_12H}`; // 12 Feb 1:14 PM
const DOYTIME_SEC_12H = `${DAY_OF_YEAR} ${TIME_SEC_12H}`; // 12 Feb 1:14:00 PM

const DOYTIME_MIN_24H = `${DAY_OF_YEAR} ${TIME_MIN_24H}`; // 12 Feb 13:14 PM
const DOYTIME_SEC_24H = `${DAY_OF_YEAR} ${TIME_SEC_24H}`; // 12 Feb 13:14:00 PM

const DATE_FORMATS = {
    DEFAULT: DATETIME_MIN_12H,
    DOY_DEFAULT: DOYTIME_MIN_12H,

    DAY_OF_YEAR,
    DATE,
    DATE_FIELD,
    TZ,

    TIME_MIN_24H,
    TIME_MIN_24H_TZ,
    TIME_SEC_24H,
    TIME_SEC_24H_TZ,

    TIME_MIN_12H,
    TIME_MIN_12H_TZ,
    TIME_SEC_12H,
    TIME_SEC_12H_TZ,

    DATETIME_MIN_24H,
    DATETIME_SEC_24H,
    DATETIME_MIN_24H_TZ,
    DATETIME_SEC_24H_TZ,

    DATETIME_MIN_12H,
    DATETIME_SEC_12H,
    DATETIME_MIN_12H_TZ,
    DATETIME_SEC_12H_TZ,

    DOYTIME_MIN_12H,
    DOYTIME_SEC_12H,
    DOYTIME_MIN_24H,
    DOYTIME_SEC_24H,

    CHART_HOUR12,
    CHART_HOUR24,
    CHART_DAY,
    CHART_WEEK,
};

export default DATE_FORMATS;
